// extracted by mini-css-extract-plugin
export default {"infoTooltip":"IgnoreSpacesAndCase_infoTooltip__1m3fT","checkboxContainer":"IgnoreSpacesAndCase_checkboxContainer__Ev9fh"};